import { Grid, SelectField, TextAreaField, TextField } from "../Fields";
import { RELATIONSHIPS } from "../../../lib/options";

export default function StepApplicant() {
  return (
    <Grid>
      <TextField section="private" name="applicant_name" label="Name of applicant" required placeholder="Person filling this form" />
      <TextField section="private" name="applicant_mobile" label="Mobile / contact number" required inputMode="numeric" maxLength={10} placeholder="10-digit mobile" />
      <TextAreaField section="private" name="applicant_full_address" label="Full address of applicant" required className="sm:col-span-2" />
      <SelectField section="private" name="relationship_with_candidate" label="Relationship with bride/groom" required options={RELATIONSHIPS} />
    </Grid>
  );
}
